import { createContext } from "react";
import type { TenantApp } from "@inloco/shared";

export interface TenantAppContextType {
    app: TenantApp | null;
    mapBlobUrl: string | null;
}

export const TenantAppContext = createContext<TenantAppContextType | null>(null);